import { Component, ViewChild } from '@angular/core';
import { ConnectorService } from 'src/app/core/services/connector.service';
import { UserContextService } from 'src/app/core/services/user-context.service';
import { SharedService } from 'src/app/core/services/shared-service';
import { SubscriptionPlanService } from 'src/app/core/services/subscription-plan.service';
import { HotGlueComponent } from 'src/app/shared/hot-glue/hot-glue.component';

@Component({
  selector: 'app-settings-connectors',
  templateUrl: './connector.component.html',
  styleUrls: ['./connector.component.css']
})
export class ConnectorsSettingsComponent {
  // Use template reference variables to distinguish the two instances.
  @ViewChild('linkedSources') LinkedSourcesPage!: HotGlueComponent;
  @ViewChild('addSource') AddSourcePage!: HotGlueComponent;

  // Controls whether the add-source popup is visible.
  showAddPopup: boolean = false;

  constructor(
    public userContextService: UserContextService,
    private subscriptionService: SubscriptionPlanService,
    private hotGlueService: ConnectorService,
    private sharedService: SharedService
  ) {}

  onScriptLoaded(): void {
    // Set up the listener for the add source (popup) instance.
    if (this.AddSourcePage) {
      this.AddSourcePage.SetOnSourceLinkedListener((source, flow_id) => {
        // When a new source is linked from the popup:
        this.showAddPopup = false; // Close the popup
        this.hotGlueService.resetLinkiedSources(); // Reset the service's linked sources (if needed)
        // Refresh the linked sources list.
        // Here, we simply call ngOnInit on the LinkedSourcesPage instance.
        // In a real app you might expose a dedicated refresh() method.
        this.LinkedSourcesPage.ngOnInit();
        this.sharedService.DisplayNotification(`Source ${source} linked successfully`, 'success');
      });

      this.AddSourcePage.SetonSourceLinkCanceled((tap, flow_id) => {
        this.sharedService.DisplayNotification(`Linking source ${tap} canceled`, 'info');
      });

      this.AddSourcePage.SetOnSourceUnlinkedListener((tap, flow_id) => {
        this.hotGlueService.HotGlue.close();
        this.hotGlueService.resetLinkiedSources(); // Reset the service's linked sources (if needed)
        // Refresh the linked sources list.
        // Here, we simply call ngOnInit on the LinkedSourcesPage instance.
        // In a real app you might expose a dedicated refresh() method.
        this.LinkedSourcesPage.ngOnInit();
        this.sharedService.DisplayNotification(`Source ${tap} unlinked successfully`, 'success');
      });

      this.AddSourcePage.SetOnCloseListener((tap, flow_id) => { 
        this.hotGlueService.HotGlue.close();
      });
    }
  }

  // Called when the "Add Source" button is clicked.
  async onAddSourceClicked(): Promise<void> {
    const subscription = this.userContextService.CurrentSubscription;
    const instance = this.userContextService.CurrentInstance;
    if (!subscription) {
      this.sharedService.DisplayNotification('No subscription found', 'error');
      return;
    }

    if (!instance) {
      this.sharedService.DisplayNotification('No instance found', 'error');
      return;
    }

    // Check if subscription is active
    if (subscription.Status !== 'Active') {
      this.sharedService.DisplayNotification('Subscription is not active', 'error');
      return;
    }

    // Check if the instance can establish another link to a source
    // under the constraints of the current subscription.
    const canLink = await subscription.CanEstablishNewConnector(instance);

    // if (!canLink) {
    //   const newCount = (await instance.GetInstanceConnectors()).length + 1;
    //   await this.subscriptionService.OpenUpgradeModal(subscription, {
    //     MaxConnector: newCount,
    //   });
    // } else {
    //   // If the subscription allows it, show the add source popup.
    //   this.showAddPopup = true;
    // }
  }
}
